let destURL = "http://192.168.0.188/golfclubje/";

if(window.location.href.indexOf("dinsdaghakkers") > -1 )destURL = "https://dinsdaghakkers.nl/server/"

class User {

  	constructor(name, year) {
		this.name = name;
		this.year = year;

		this.scores = []
		this.birdies = []
		this.ladies = []
  	}

  	addScore(s, b, l) {
		console.log("S:",s,"B:",b,"L:",l)
		if(s !== "" && s !== undefined) {
			let sf = parseFloat(s)
			this.scores.push(sf)
		}
		if( b !== "" && b !== undefined) {
			let sb = parseFloat(b)
			this.birdies.push(sb)
		}
		if( l !== "" && l !== undefined) {
			let sl = parseFloat(l)
			this.ladies.push(sl)
		}
  	}

  	getName() {
  		return this.name
  	}

  	getMeanScore(bestof) {
		//--sort
		let arr = JSON.parse(JSON.stringify(this.scores)),
			len = arr.length,
			mean = 0,
		divlen = 0,
		rv = 0

		if(len > 0) {
			arr.sort(function(a, b) {
				return b - a;
			});

			let tlen = Math.min(bestof,len)
			for(let i=0;i<tlen;i++) {
			let a = arr[i]
			mean += a
			if( parseInt(a) > 0 )divlen++
		}
		}
		if(mean > 0 && divlen > 0 )
			rv = mean / divlen;

		return parseFloat(rv).toFixed(2)
	}

	getBestScores(bestof) {
		//--sort
		let arr = JSON.parse(JSON.stringify(this.scores)),
			len = arr.length,
			rarr = []

		if(len > 0) {
			arr.sort(function(a, b) {
				return b - a;
			});
		}
		for(let i=0;i<len;i++) {
			if(i<bestof)rarr.push(arr[i])
		}
		return rarr;
	}

	getBirdies() {
		let bt = 0;
		for(let i=0;i<this.birdies.length;i++)
			bt += this.birdies[i]
		return bt;
  	}

	getLadies() {
		let lt = 0;
		for(let i=0;i<this.ladies.length;i++)
			lt += this.ladies[i]
		return lt;
  	}
}

let userArr = {}

// Check if column index is a "name" column (1, 4, 7, 10, ... = 1 + n*3)
function isNameColumn(num) { return num > 0 && (num - 1) % 3 === 0; }

const createUserData = (d) => {
	let i, j
	// Reset userArr for fresh data
	userArr = {}
//	console.log(d, d.length)
	for(i=0;i<d.length;i++) {
//		console.log(i, d[i])
		//-- create users from row 0 (names row)
		if( i === 0 ) {
			for(j=0;j<d[i].length;j++) {
				// Names are at positions 1, 4, 7, 10... (every 3rd column starting at 1)
				if( isNameColumn(j) && (""+d[i][j]).length > 2 ) {
					let uname = ""+d[i][j];
					let ud = new User(uname,"");
					userArr[j] = ud;
				}
			}
		}
		//-- process data from row 2 onwards (row 1 is headers)
		else if( i >= 2 ) {
			for(j=0;j<d[i].length;j++) {
				// Score columns are at positions 1, 4, 7, 10... (same as name columns)
				if( isNameColumn(j) && userArr[j] ) {
					// j = score, j+1 = birdies, j+2 = ladies
					userArr[j].addScore(d[i][j], d[i][j+1], d[i][j+2]);
				}
			}
		}
	}
	return userArr;
}

export {
	destURL,
	createUserData,
	userArr,
}
